import { Provider } from 'react-redux';
import store from './store/store';
import { history } from './store/history';
// Allowed use of connected-react-router
// eslint-disable-next-line no-restricted-imports
import { ConnectedRouter } from 'connected-react-router';
import HttpsRedirect from 'react-https-redirect';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/style';
import Routes from './routes';

const Root = () => {
    return (
        <HttpsRedirect disabled={process.env.NODE_ENV === 'development'}>
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <ThemeProvider theme={theme}>
                        <Routes />
                    </ThemeProvider>
                </ConnectedRouter>
            </Provider>
        </HttpsRedirect>
    );
};

export default Root;
